// ============================================================
//  Dynamic Tab Management — Types & Interfaces
// ============================================================

export interface DynamicTab {
  id: string;
  label: string;
  slug: string;
  icon?: string;
  order: number;
  isDefault?: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TabSettings {
  tabs: DynamicTab[];
  maxTabs: number;
  allowReorder: boolean;
  allowDelete: boolean;
  allowAdd: boolean;
}

export interface TabManagerState {
  tabs: DynamicTab[];
  activeTab: string;
  editing: string | null;
  draggedTab: string | null;
  settings: TabSettings;
  isInitialized: boolean;
}

export interface TabAction {
  type:
    | 'SET_TABS'
    | 'ADD_TAB'
    | 'UPDATE_TAB'
    | 'DELETE_TAB'
    | 'REORDER_TABS'
    | 'SET_ACTIVE'
    | 'SET_EDITING'
    | 'SET_DRAGGING';
  payload?: any;
}

// Default tab configuration
export const DEFAULT_TABS: DynamicTab[] = [
  {
    id: 'accueil',
    label: 'Accueil',
    slug: 'accueil',
    order: 0,
    isDefault: true,
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'offres',
    label: 'Nos Offres',
    slug: 'offres',
    order: 1,
    isDefault: false,
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 'validation',
    label: 'Validation',
    slug: 'validation',
    order: 2,
    isDefault: false,
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

export const DEFAULT_TAB_SETTINGS: TabSettings = {
  tabs: DEFAULT_TABS,
  maxTabs: 10,
  allowReorder: true,
  allowDelete: true,
  allowAdd: true,
};
